import React from 'react'; 
import { render } from 'react-dom';
import { BrowserRouter, } from 'react-router-dom';

//Import the components
import App from './components/App';
import MessageBar from './shared/components/MessageBar';
import GlobalLoader from './shared/components/Loader';

//Import the services
import { logout, getTenantInfo } from './components/user/services/Authentication';

//Import the resource 
import './styles/index.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import * as serviceWorker from './serviceWorker';
import { JobQueueProvider } from './components/layout/header/JobQueueContext';

const LogoutStyle = {
  awsloader:{
    position: "absolute",margin: "auto",width: "20%",height: "20%",top: '0',
    left: '0',bottom: '0',right: '0',fontSize: '20px',fontWeight: 'bold'
  } 
}

//Creating the Custom tags
class BbhLoading extends HTMLElement {}

class BbhNodata extends HTMLElement {}

class BbhCharts extends HTMLElement {}

class BbhStatistic extends HTMLElement {}

class BbhIcons extends HTMLElement {}

class BbhWidget extends HTMLElement {}

// class BBHChartGraph extends HTMLElement {}

//Defining the tag and adding tab into Window object
window.customElements.define('bbh-loading', BbhLoading);
window.customElements.define('bbh-nodata', BbhNodata);
window.customElements.define('bbh-charts', BbhCharts);
window.customElements.define('bbh-statistic', BbhStatistic);
window.customElements.define('bbh-icons', BbhIcons);
window.customElements.define('bbh-widget', BbhWidget);
// window.customElements.define('bbh-charts-graph', BBHChartGraph);


class Root extends React.Component {

  constructor(props) {
    super(props);
    this.state = { 
     user: null,
     messageBar:{open:false,message:"",variant:"success",props:{}},
     loggedIn:null,
     isLoading:false,
     fullPageLoading:false,
     isSFTicketHolded:false,
     openCreateTicketBox:false,
     awsLogoutLoading: false
    };
    this.addToState.bind(this);
  }

  async UNSAFE_componentWillMount(){        
    if(sessionStorage.getItem('user')){
      let user = JSON.parse(sessionStorage.getItem('user'));
      let Menus = JSON.parse(sessionStorage.getItem('menus'));
      let states= {user,menus:Menus};
      if(sessionStorage.getItem('loggedIn')){
        let loggedInTenant = JSON.parse(sessionStorage.getItem('loggedIn'));
        states.loggedIn= loggedInTenant;
        states.tenantmenus= loggedInTenant.menus?loggedInTenant.menus:[];
      }
      this.setState(states);
    }
    if(sessionStorage.getItem('hosttoken')){
      let hosttoken = sessionStorage.getItem('hosttoken');
      let tenantConfig = JSON.parse(sessionStorage.getItem('tenantConfig'));
      await this.setState({hosttoken,tenantConfig});
    }else{
      try {
        this.setState({ 
          fullPageLoading: true
        });
        let response = await getTenantInfo();
        if (response.data) {
          sessionStorage.setItem('tenantConfig', JSON.stringify(response.data.tenantConfig));
          sessionStorage.setItem('hosttoken', response.data.hosttoken);
          this.setState({ 
            fullPageLoading: false,
            tenantConfig: response.data.tenantConfig,
            hosttoken: response.data.hosttoken
          });
        }

      } catch (ex) {
        this.setState({ 
          fullPageLoading: false,
          isLoading: false,
        });
        this.showMessage('error', ex.message);
      }
    }
    this.addFavicon();
    
  }

  addFavicon = ()=>{
    const favicon= document.getElementById('favicon');
      if(this.state.tenantConfig && this.state.tenantConfig.faviconUrl){
        favicon.href=this.state.tenantConfig.faviconUrl
      }
  }
  addToState = (key,value) =>{
    this.setState({[key]:value});
  }

  showMessage = (variant,message,otherProps={}) =>{
    this.setState({messageBar:{open:true,message:message,variant:variant,otherProps:otherProps}});
  }

  disableMessage = () =>{
    this.setState((oldState)=>(
      {
        messageBar: {
          ...oldState.messageBar,
          open: false
        }
      }
    ));
  }

  logoutUser = async () =>{
    await logout();
    let AWSCode = sessionStorage.getItem('AWSCode');
    var getConfig = sessionStorage.getItem('tenantConfig');
    if(JSON.parse(getConfig) && JSON.parse(getConfig).logoutUrl && AWSCode){
      this.setState({awsLogoutLoading: true});
    }
    sessionStorage.clear();
    sessionStorage.setItem('tenantConfig',getConfig);
    this.setState(
      { 
        user: null,
        menus:null,
        hosttoken:undefined,
        // tenantConfig:getConfig,
        loggedIn:null,
        contractSummary:null,
        isSFTicketHolded:false,
        openCreateTicketBox:false
      }
    );
  }
  isSFHoldedTicket = () =>{
      let ticketInfo= JSON.parse(sessionStorage.getItem('holdSFTicket'));
      if(ticketInfo && ticketInfo.isAllowHold){
          return true;
      }
      return false;
  }

  
  render(){
    // Show a text before the aws logout page loads 
    if(this.state.awsLogoutLoading){
      return (
        <div style={LogoutStyle.awsloader}><p>Logging out....</p></div>
      )
    }
    if(this.state.fullPageLoading){
      return <GlobalLoader />
    }
    return (
        <div>
          <MessageBar 
              open={this.state.messageBar.open} 
              message={this.state.messageBar.message} 
              variant={this.state.messageBar.variant} 
              disableMessage={this.disableMessage}
              otherProps={this.state.messageBar.otherProps}
          />
          {this.state.isLoading && <GlobalLoader />}
          <JobQueueProvider>
            <BrowserRouter {...this.state} addToState={this.addToState} showMessageBar={this.showMessage} logoutUser={this.logoutUser} disableMessage={this.disableMessage} isSFHoldedTicket={this.isSFHoldedTicket} >
                <App {...this.state} addToState={this.addToState} showMessageBar={this.showMessage} logoutUser={this.logoutUser} disableMessage={this.disableMessage}  isSFHoldedTicket={this.isSFHoldedTicket} />
            </BrowserRouter>
          </JobQueueProvider>
        </div>
    )
  }
  
}

render(<Root />, document.getElementById('root'));


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
